import React from 'react';
import narsLogo from '../assets/nars-cosmetics-logo.png';
import hudaBeautyLogo from '../assets/huda-beauty-logo.png';
import charlotteTilburyLogo from '../assets/charlotte-tilbury-logo.png';
import macCosmeticsLogo from '../assets/mac-cosmetics-logo.png';
import diorLogo from '../assets/dior-logo.png';
import lorealLogo from '../assets/loreal-logo.png';
import maybellineLogo from '../assets/maybelline-logo.png';
import sugarLogo from '../assets/sugar-logo.png';

const BrandsMarqueeStrip = () => {
  const cosmeticBrands = [
    { id: 1, name: 'NARS', logo: narsLogo },
    { id: 2, name: 'HUDA Beauty', logo: hudaBeautyLogo },
    { id: 3, name: 'Charlotte Tilbury', logo: charlotteTilburyLogo },
    { id: 4, name: 'MAC Cosmetics', logo: macCosmeticsLogo },
    { id: 5, name: 'Dior', logo: diorLogo },
    { id: 6, name: 'L\'Oréal', logo: lorealLogo },
    { id: 7, name: 'Maybelline', logo: maybellineLogo },
    { id: 8, name: 'Sugar Cosmetics', logo: sugarLogo }
  ];

  return (
    <div className="w-full bg-white py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-hero font-medium text-[#622935] mb-6 font-display">
            Partner Brands
          </h2>
          <p className="text-lg md:text-xl text-black font-body">
            Trusted by leading beauty brands worldwide
          </p>
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-8 items-center justify-items-center">
          {cosmeticBrands.map((brand) => (
            <div
              key={brand.id}
              className="w-full max-w-[160px] h-16 sm:h-20 flex items-center justify-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md hover:scale-105 transition-all duration-300 cursor-pointer group border border-gray-300"
            >
              <img
                src={brand.logo}
                alt={`${brand.name} logo`}
                className="max-h-10 sm:max-h-12 w-auto object-contain opacity-100  transition-all duration-300"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandsMarqueeStrip;